import * as types from '../../mutationTypes';

export default {
  /* eslint-disable no-param-reassign */
  [types.RESET_CLIENT](state) {
    state.appId = null;
    state.id = null;
    state.name = '';
    state.subdomain = '';
    state.displayName = '';
    state.logoUri = '';
    state.parentId = null;
    state.parent = null;
    state.children = null;
    state.assuranceApiKey = null;
    state.assuranceTenant = null;
    state.universalId = null;
  },

  [types.UPDATE_CLIENT](state, client) {
    state.appId = client.appId;
    state.id = client.id;
    state.name = client.name;
    state.subdomain = client.subdomain;
    state.displayName = client.displayName;
    state.logoUri = client.logoUri;
    state.parentId = client.parentId;
    state.parent = client.parent;
    state.children = client.children;
    state.assuranceApiKey = client.assuranceApiKey;
    state.assuranceTenant = client.assuranceTenant;
    state.universalId = client.universalId;
  },

  [types.SET_ACCESS_DETAILS](state, accessDetails) {
    state.accessDetails = { ...accessDetails };
  }
  /* eslint-enable no-param-reassign */
};
